class RGBA {
    constructor(r, g, b, a = 1) {
        this.r = r
        this.g = g
        this.b = b
        this.a = a
    }

    toString() {
        return `rgba(${this.r}, ${this.g}, ${this.b}, ${this.a})`
    }

    static fromHex(hex) {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)

        return result ? new this(parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)) : null
    }
}

module.exports = RGBA



/** WEBPACK FOOTER **
 ** ./js/credentials/RGBA.js
 **/